import React, {useContext} from "react";
import {Text, View} from '@react-pdf/renderer';
import PropTypes from "prop-types";

import PrintDocumentInfoFabricator from "./printDocumentInfoFabricator";
import {PrintDocumentContext} from "./printDocumentContext";

export const getAddressFromObject = (userInfo) => {
  let displayAddress = "";
  [userInfo.city, userInfo.state, userInfo.postal].forEach(addressPart => { // 1) city 2) provence 3) postal
    if (addressPart) {
      if (displayAddress) {
        displayAddress += ", "
      }
      displayAddress += addressPart
    }
  });
  return displayAddress
}

const PrintDocumentInfo = (props) => {
  const {styles, userInfo, fabricatorData, assignQuotePopupCustomer, employeeSelected} = props;
  const customerName = assignQuotePopupCustomer
    ? assignQuotePopupCustomer.fullName
    : userInfo.firstName + (userInfo.lastName ? (" " + userInfo.lastName) : "")
  const customerEmail = assignQuotePopupCustomer ? assignQuotePopupCustomer.email : userInfo.email || ""
  const customerPhone = userInfo.phoneNumber
    ? userInfo.country && !userInfo.phoneNumber.includes(`+${userInfo.country.dialCode} `)
      ? `+${userInfo.country.dialCode} ${userInfo.phoneNumber}`
      : userInfo.phoneNumber
    : "";
  const customerAddress = getAddressFromObject(userInfo);
  const customerHasShippingAddress = userInfo.shipping && (["address1", "city", "postal"].some(key => {
    return userInfo.shipping[key] && (userInfo[key] !== userInfo.shipping[key])
  }));
  let shippingAddress = "";
  if (customerHasShippingAddress) {
    shippingAddress = getAddressFromObject(userInfo.shipping);
  }
  const threeColumns = (employeeSelected || (customerHasShippingAddress && !fabricatorData.isCaesarStone))
    && !fabricatorData.isAmericanStandard;
  const printContext = useContext(PrintDocumentContext);

  return (
    <View style={styles.main}>
      <View style={threeColumns ? [styles.section, styles.sectionLeft] : [styles.sectionTwo, styles.sectionLeft]}>
        <Text style={styles.mainTitle}>{printContext.messages["receipt.mainInfo.customerInformation"]}</Text>
        <Text style={styles.mainText}>{customerName}</Text>
        {userInfo.address1 ? <Text style={styles.mainText}>{userInfo.address1}</Text> : null}
        {customerAddress ? <Text style={styles.mainText}>{customerAddress}</Text> : null}
        <Text style={[styles.mainText, styles.mainTextEmail]}>{customerEmail}</Text>
        <Text style={styles.mainText}>{customerPhone}</Text>
      </View>
      {threeColumns ? (
        <View style={[styles.section, styles.sectionCenter]}>
          {!fabricatorData.isCaesarStone && (shippingAddress || userInfo.shipping.address1)
            ? <Text style={styles.mainTitle}>{printContext.messages["receipt.mainInfo.billingAddress"]}</Text>
            : null}
          {!fabricatorData.isCaesarStone && userInfo.shipping.address1
            ? <Text style={styles.mainText}>{userInfo.shipping.address1}</Text>
            : null}
          {!fabricatorData.isCaesarStone && shippingAddress
            ? <Text style={styles.mainText}>{shippingAddress}</Text>
            : null}
          {employeeSelected ? (
            <Text style={!fabricatorData.isCaesarStone && (shippingAddress || userInfo.shipping.address1)
              ? [styles.mainTitle, styles.mainTextEmail] : styles.mainTitle}>
              {printContext.messages["receipt.mainInfo.salesPerson"]}
            </Text>
          ) : null}
          {employeeSelected ? <Text style={styles.mainText}>{employeeSelected.fullName}</Text> : null}
        </View>
      ) : null}
      <PrintDocumentInfoFabricator fabricatorData={fabricatorData} threeColumns={!!threeColumns} styles={styles}/>
    </View>
  )
};

PrintDocumentInfo.propTypes = {
  userInfo: PropTypes.object.isRequired,
  fabricatorData: PropTypes.object.isRequired,
  assignQuotePopupCustomer: PropTypes.object,
  styles: PropTypes.object.isRequired,
};

export default PrintDocumentInfo
